import {
  CompanyPageCompanyFragment,
  useCompanyRolesQuery,
} from 'generated/graphql';
import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import CompanyRolesList from './CompanyRolesList/CompanyRolesList';
import styles from './MfaTab.module.scss';

type MfaTabProps = {
  company: CompanyPageCompanyFragment;
};

const MfaTab = ({ company }: MfaTabProps) => {
  const { handleMsgType } = useNotification();
  const companyRolesQueryResponse = useCompanyRolesQuery({
    variables: {
      companyId: company.id,
    },
    onError: error => {
      handleMsgType({ type: TNotification.error, message: error?.message });
    },
  });
  if (companyRolesQueryResponse.loading) {
    return (
      <div className={styles.loader}>
        <CircularProgress />
      </div>
    );
  }
  if (companyRolesQueryResponse.error) {
    return (
      <div>
        <label>{companyRolesQueryResponse.error.message}</label>
      </div>
    );
  }
  if (companyRolesQueryResponse.data) {
    return (
      <>
        <div className={styles.container}>
          {company.logoUrl && (
            <div className={styles.companyData}>
              <img
                src={company.logoUrl}
                alt="logo"
                className={styles.companyLogo}
              />
              <Typography variant="h5" style={{ marginLeft: '10px' }}>
                {company.name}
              </Typography>
            </div>
          )}
          {companyRolesQueryResponse.data?.CompanyRoles &&
          companyRolesQueryResponse.data?.CompanyRoles?.length > 0 ? (
            <CompanyRolesList
              companyRoles={companyRolesQueryResponse.data?.CompanyRoles}
              company={company}
            />
          ) : null}
        </div>
      </>
    );
  }
  return null;
};
export default MfaTab;
